import React from 'react';
import Medical from '../assets/images/icon-medical.svg';

export default () => {
  return <img src={Medical} alt="" />;
};
